import top from './assets/images/top.png'
import jungle from './assets/images/jungle.png'
import midlane from './assets/images/midlane.png'
import marksman from './assets/images/marksman.png'
import support from './assets/images/support.png'

const initialPositionImages = [top, jungle, midlane, marksman, support]

export default initialPositionImages